// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f3d9a2e0","888":"8aac1cef","977":"3429af0c"}[chunkId] + ".chunk.js";
};